import * as React from 'react'

import {
  ContentItem,
  WishlistButton,
} from '@thg-commerce/enterprise-components'
import { WishlistButtonType } from '@thg-commerce/enterprise-components/Product/src/WishlistButton/WishlistButton'
import { VariantFields } from '@thg-commerce/enterprise-components/src/transformer/productOptionsTransformer'
import {
  useCustomer,
  useFormattableI18nProperty,
  useI18n,
} from '@thg-commerce/enterprise-core'
import {
  WishlistButtonPDPStyle,
  WishlistButtonStyleInterface,
} from '@thg-commerce/enterprise-pages/src/Product/theme'

interface SelectedVariant extends VariantFields {
  externalIdentifier?: string
}
export interface WishlistButtonRendererProps {
  selectedVariant?: SelectedVariant
  buttonWithoutText?: boolean
  buttonStyle?: WishlistButtonStyleInterface
  buttonType: WishlistButtonType
  wishlistPDPButtonStyle?: WishlistButtonPDPStyle
  itemCategories?: ContentItem[]
  brandName?: string
  externalIdentifier?: string | null
}

export const WishlistButtonRenderer = (props: WishlistButtonRendererProps) => {
  const customer = useCustomer()
  const i18n = useI18n()

  const [inWishlist, setInWishlist] = React.useState(
    props.selectedVariant?.sku
      ? customer?.wishlist?.skus.includes(
          parseInt(props.selectedVariant?.sku, 10),
        )
      : false,
  )

  React.useEffect(() => {
    setInWishlist(
      !!customer?.wishlist?.skus.includes(
        parseInt(props.selectedVariant?.sku || '', 10),
      ),
    )
  }, [customer?.wishlist, props.selectedVariant?.sku])

  const i18nText = {
    addToWishlistTextDynamic: useFormattableI18nProperty(
      'product.addtowishlistbutton.addtowishlist.text.dynamic',
    ),
    addToWishlistText: i18n('product.addtowishlistbutton.addtowishlist.text'),
    savedToWishlistText: i18n(
      'product.addtowishlistbutton.savedtowishlist.text',
    ),
    wishlistTooltip: {
      closeButtonText: i18n('product.addtowishlist.tooltip.button.close.text'),
    },
    wishlistTooltipContent: {
      loginSignupText: i18n('product.addtowishlist.tooltip.loginsignup.text'),
      toUseWishlistText: i18n('product.addtowishlist.tooltip.text'),
    },
  }

  if (!props.selectedVariant?.sku) {
    return null
  }

  return (
    <WishlistButton
      i18nText={i18nText}
      sku={parseInt(props.selectedVariant.sku, 10)}
      inWishlist={inWishlist}
      addToWishlistCallback={() => {
        setInWishlist(true)
      }}
      removeFromWishlistCallback={() => {
        setInWishlist(false)
      }}
      buttonWithoutText={props.buttonWithoutText}
      buttonStyle={props.buttonStyle}
      title={props.selectedVariant?.title}
      price={props.selectedVariant?.price?.price.amount}
      buttonType={props.buttonType}
      wishlistPDPButtonStyle={props.wishlistPDPButtonStyle}
      itemCategories={props.itemCategories}
      brandName={props.brandName}
      externalIdentifier={props.externalIdentifier}
      variantChildSku={props.selectedVariant?.externalIdentifier}
    />
  )
}
